import React, { useContext } from 'react'
import { QuizContext } from '../contexts/QuizContext'

const Content = () => {

	const quizContext = useContext(QuizContext)

	return (
		<div className="content">
			<div className="container">
			{ quizContext.curQuestion === 0 ?
			<div>
			This is your quiz center, by clicking "Start Quiz" above, you will
			be asked 10 questions.  You will gain one point for every question answered right.<br /><br />

			All in All, Good Luck!
			</div> : <div align="center">
				Score: {quizContext.score}
			</div>
			}
			</div>
		</div>
	)
}

export default Content
